// extracted by mini-css-extract-plugin
module.exports = {"application":"Y8NJGb-1uL00zkwQ3u-vZw=="};